
export enum ApiContractExceptionSeverityCd {
	ERROR = 'Error',
	INFO = 'Info',
	WARNING = 'Warning'}

